import React, { useState, useEffect } from 'react';

function MartCMSPreview() {
  return (
    <div style={{
      background: '#111827', borderRadius: 14, overflow: 'hidden',
      border: '1px solid rgba(255,255,255,0.1)',
      boxShadow: '0 24px 60px rgba(0,0,0,0.5)',
      fontFamily: 'Inter, sans-serif',
    }}>
      {/* Window bar */}
      <div style={{ background: '#1e2d45', padding: '10px 16px', display: 'flex', alignItems: 'center', gap: 8, borderBottom: '1px solid rgba(255,255,255,0.06)' }}>
        {['#ef4444','#f59e0b','#22c55e'].map(c => <div key={c} style={{ width: 10, height: 10, borderRadius: '50%', background: c, opacity: 0.8 }} />)}
        <span style={{ fontSize: 11, color: 'rgba(255,255,255,0.35)', marginLeft: 8, fontWeight: 600, letterSpacing: '0.5px' }}>Mart CMS — Dashboard</span>
      </div>
      {/* KPI row */}
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3,1fr)', gap: 1, background: 'rgba(255,255,255,0.03)', padding: '1px', margin: '12px 12px 0' }}>
        {[['₹2.4L','Gross Sales','#60a5fa'],['128','Total Orders','#34d399'],['₹1,875','Avg Order Value','#f59e0b']].map(([v,l,c]) => (
          <div key={l} style={{ background: '#1e2d45', padding: '10px 12px', borderRadius: 8 }}>
            <div style={{ fontSize: 9, color: 'rgba(255,255,255,0.4)', marginBottom: 3, textTransform: 'uppercase', letterSpacing: '0.6px' }}>{l}</div>
            <div style={{ fontFamily: 'Plus Jakarta Sans, sans-serif', fontSize: 18, fontWeight: 800, color: c, letterSpacing: '-0.5px' }}>{v}</div>
          </div>
        ))}
      </div>
      {/* Mini bar chart */}
      <div style={{ padding: '12px 12px 8px' }}>
        <div style={{ fontSize: 9, color: 'rgba(255,255,255,0.3)', marginBottom: 8, textTransform: 'uppercase', letterSpacing: '0.6px', fontWeight: 600 }}>Monthly Sales Trend</div>
        <div style={{ display: 'flex', alignItems: 'flex-end', gap: 4, height: 52, background: '#1a2436', borderRadius: 8, padding: '8px 10px' }}>
          {[30,55,40,70,50,85,65,78,45,92,60,75].map((h, i) => (
            <div key={i} style={{ flex: 1, height: h * 0.44 + 'px', background: i === 9 ? '#2563eb' : 'rgba(37,99,235,0.3)', borderRadius: '3px 3px 0 0', transition: 'height 0.8s ease' }} />
          ))}
        </div>
      </div>
      {/* Nav items */}
      <div style={{ padding: '6px 12px 12px', display: 'flex', gap: 6, flexWrap: 'wrap' }}>
        {['Customers','Orders','Inventory','POS','Offers'].map(item => (
          <div key={item} style={{ fontSize: 10, padding: '4px 10px', background: 'rgba(37,99,235,0.15)', color: '#60a5fa', borderRadius: 5, fontWeight: 600, border: '1px solid rgba(37,99,235,0.25)' }}>{item}</div>
        ))}
      </div>
    </div>
  );
}

function POSPreview() {
  return (
    <div style={{
      background: 'linear-gradient(160deg,#1e3a8a 0%,#1d4ed8 40%,#2563eb 100%)',
      borderRadius: 14, overflow: 'hidden',
      border: '1px solid rgba(255,255,255,0.15)',
      boxShadow: '0 24px 60px rgba(0,0,0,0.4)',
    }}>
      <div style={{ background: 'rgba(0,0,0,0.2)', padding: '10px 16px', display: 'flex', alignItems: 'center', gap: 8, borderBottom: '1px solid rgba(255,255,255,0.1)' }}>
        {['#ef4444','#f59e0b','#22c55e'].map(c => <div key={c} style={{ width: 10, height: 10, borderRadius: '50%', background: c, opacity: 0.8 }} />)}
        <span style={{ fontSize: 11, color: 'rgba(255,255,255,0.5)', marginLeft: 8, fontWeight: 600, letterSpacing: '0.5px' }}>POS-Lite — Billing Counter</span>
      </div>
      <div style={{ padding: '12px' }}>
        <div style={{ fontSize: 9, color: 'rgba(255,255,255,0.5)', marginBottom: 8, textTransform: 'uppercase', letterSpacing: '0.6px', fontWeight: 600 }}>Products</div>
        {[['Lava Cake','SKU45','1083 in stock','₹90.00'],['Jar Cake','sku45','4 in stock','₹8.00']].map(([name,sku,stock,price]) => (
          <div key={name} style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', background: 'rgba(255,255,255,0.1)', borderRadius: 8, padding: '8px 10px', marginBottom: 6, backdropFilter: 'blur(4px)' }}>
            <div>
              <div style={{ fontSize: 12, color: 'white', fontWeight: 600 }}>{name}</div>
              <div style={{ fontSize: 9, color: 'rgba(255,255,255,0.5)' }}>SKU #{sku}</div>
            </div>
            <div style={{ textAlign: 'right' }}>
              <div style={{ fontSize: 11, color: '#bfdbfe', marginBottom: 2 }}>{stock}</div>
              <div style={{ fontSize: 13, color: 'white', fontWeight: 700 }}>{price}</div>
            </div>
            <div style={{ width: 28, height: 28, borderRadius: 6, background: 'rgba(255,255,255,0.2)', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 14, cursor: 'pointer', marginLeft: 8 }}>🛒</div>
          </div>
        ))}
        {/* Cart */}
        <div style={{ background: 'rgba(0,0,0,0.2)', borderRadius: 8, padding: '10px 12px', marginTop: 8 }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 6 }}>
            <span style={{ fontSize: 11, color: 'rgba(255,255,255,0.6)', fontWeight: 600 }}>Cart Summary</span>
            <span style={{ fontSize: 11, color: '#bfdbfe' }}>2 items</span>
          </div>
          <div style={{ display: 'flex', justifyContent: 'space-between' }}>
            <span style={{ fontSize: 12, color: 'rgba(255,255,255,0.7)' }}>Grand Total</span>
            <span style={{ fontSize: 14, color: 'white', fontWeight: 800, fontFamily: 'Plus Jakarta Sans, sans-serif' }}>₹98.00</span>
          </div>
        </div>
      </div>
    </div>
  );
}

export default function Hero() {
  const [activeTab, setActiveTab] = useState(0);
  const nav = id => document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });

  useEffect(() => {
    const t = setInterval(() => setActiveTab(a => (a + 1) % 2), 4000);
    return () => clearInterval(t);
  }, []);

  return (
    <section style={{
      background: 'linear-gradient(160deg,#060d1a 0%,#0c1220 45%,#0f172a 100%)',
      minHeight: '100vh', paddingTop: 70,
      display: 'flex', alignItems: 'center',
      position: 'relative', overflow: 'hidden',
    }}>
      {/* BG grid */}
      <div style={{ position: 'absolute', inset: 0, pointerEvents: 'none',
        backgroundImage: 'linear-gradient(rgba(37,99,235,0.04) 1px,transparent 1px),linear-gradient(90deg,rgba(37,99,235,0.04) 1px,transparent 1px)',
        backgroundSize: '60px 60px' }} />
      {/* Glow orbs */}
      <div style={{ position: 'absolute', top: '10%', left: '-5%', width: 500, height: 500, borderRadius: '50%', background: 'radial-gradient(circle,rgba(37,99,235,0.12) 0%,transparent 65%)', pointerEvents: 'none' }} />
      <div style={{ position: 'absolute', bottom: '10%', right: '-5%', width: 400, height: 400, borderRadius: '50%', background: 'radial-gradient(circle,rgba(99,102,241,0.1) 0%,transparent 65%)', pointerEvents: 'none' }} />

      <div className="container" style={{ position: 'relative', zIndex: 1, paddingTop: 60, paddingBottom: 80 }}>
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 64, alignItems: 'center' }}>
          {/* Left */}
          <div>
            {/* Badge */}
            <div style={{ display: 'inline-flex', alignItems: 'center', gap: 8, background: 'rgba(37,99,235,0.12)', border: '1px solid rgba(37,99,235,0.3)', borderRadius: 20, padding: '6px 16px', marginBottom: 28 }}>
              <span style={{ width: 6, height: 6, borderRadius: '50%', background: '#60a5fa', display: 'inline-block', animation: 'hpulse 2s infinite' }} />
              <span style={{ fontSize: 12, color: '#93c5fd', fontWeight: 600 }}>Mart CMS + POS-Lite — Now Live</span>
            </div>

            <h1 className="t-hero" style={{ color: 'white', marginBottom: 8, lineHeight: 1.04 }}>
              One Retail<br />
              <span style={{ background: 'linear-gradient(90deg,#60a5fa,#818cf8)', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent' }}>Platform.</span><br />
              Every Store.
            </h1>
            <h2 style={{ fontFamily: 'Plus Jakarta Sans, sans-serif', fontSize: 'clamp(20px,2.5vw,28px)', fontWeight: 600, color: '#60a5fa', letterSpacing: '-0.5px', marginBottom: 24 }}>Every Counter.</h2>

            <p style={{ fontSize: 18, color: 'rgba(255,255,255,0.6)', lineHeight: 1.7, marginBottom: 36, maxWidth: 480 }}>
              Manage products, inventory, billing, orders, customers, franchises, and deliveries from one connected retail ecosystem.
            </p>

            <div style={{ display: 'flex', gap: 14, flexWrap: 'wrap', marginBottom: 44 }}>
              <button className="btn btn-blue btn-lg" onClick={() => nav('contact')}>
                Book a Free Demo
                <span style={{ fontSize: 16 }}>→</span>
              </button>
              <button className="btn btn-ghost" onClick={() => nav('products')}>
                Explore Platform
              </button>
            </div>

            {/* Stats */}
            <div style={{ display: 'flex', gap: 32, flexWrap: 'wrap' }}>
              {[['500+','Stores Powered'],['2 Apps','Customer + Porter'],['Real-Time','Inventory Sync'],['Unified','Reporting']].map(([n,l]) => (
                <div key={l}>
                  <div style={{ fontFamily: 'Plus Jakarta Sans, sans-serif', fontSize: 22, fontWeight: 800, color: 'white', letterSpacing: '-0.6px' }}>{n}</div>
                  <div style={{ fontSize: 12, color: 'rgba(255,255,255,0.4)', marginTop: 2 }}>{l}</div>
                </div>
              ))}
            </div>
          </div>

          {/* Right — dual preview */}
          <div style={{ position: 'relative' }}>
            {/* Tab toggles */}
            <div style={{ display: 'flex', gap: 8, marginBottom: 16 }}>
              {['Mart CMS — Management Portal','POS-Lite — Billing Counter'].map((label, i) => (
                <button key={i} onClick={() => setActiveTab(i)} style={{
                  flex: 1, padding: '9px 12px', borderRadius: 9, border: 'none',
                  background: activeTab === i ? (i === 0 ? '#1e2d45' : 'rgba(37,99,235,0.8)') : 'rgba(255,255,255,0.05)',
                  color: activeTab === i ? 'white' : 'rgba(255,255,255,0.45)',
                  fontFamily: 'Plus Jakarta Sans, sans-serif', fontSize: 12, fontWeight: 700,
                  cursor: 'pointer', transition: 'all 0.2s',
                  borderBottom: activeTab === i ? (i === 0 ? '2px solid #2563eb' : '2px solid #60a5fa') : '2px solid transparent',
                }}>{i === 0 ? '🖥 Mart CMS' : '🧾 POS-Lite'}</button>
              ))}
            </div>
            <div style={{ transition: 'opacity 0.4s ease', opacity: 1 }}>
              {activeTab === 0 ? <MartCMSPreview /> : <POSPreview />}
            </div>
            {/* Floating badge */}
            <div style={{
              position: 'absolute', bottom: -18, left: '50%', transform: 'translateX(-50%)',
              background: 'rgba(6,13,26,0.9)', border: '1px solid rgba(37,99,235,0.3)',
              borderRadius: 20, padding: '8px 20px', backdropFilter: 'blur(10px)',
              display: 'flex', alignItems: 'center', gap: 8, whiteSpace: 'nowrap',
            }}>
              <span style={{ width: 8, height: 8, borderRadius: '50%', background: '#22c55e', display: 'inline-block' }} />
              <span style={{ fontSize: 12, color: 'rgba(255,255,255,0.7)', fontWeight: 600 }}>Live Data — All Systems Operational</span>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom fade */}
      <div style={{ position: 'absolute', bottom: 0, left: 0, right: 0, height: 100, background: 'linear-gradient(transparent,#f9fafb)', pointerEvents: 'none' }} />
      <style>{`
        @keyframes hpulse{0%,100%{opacity:1}50%{opacity:0.4}}
        @media(max-width:900px){.hero-grid{grid-template-columns:1fr!important}.hero-preview{display:none!important}}
      `}</style>
    </section>
  );
}
